import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { registerCart } from '../../../../../../../services/ebon/actions';

import { formatAmountCurrency } from '../../../../../../../utils';

import BasketRowItem from './BasketRowItem';
import ButtonComponent from '../../../../../../button/ButtonComponent';

import './EbonSelectorRightContainerStyle.scss';

const EbonSelectorRightContainer = ({
    partner,
    cart,
    handleItemChange,
    getCartTotal,
    isBasketLimitReached,
    loginRequired,
    showLoginModal,
    validatedCashbackAmount,
    i18n,
    registerCart
}) => {
    const cartValidation = () => {
        registerCart(cart);
    };

    const doCartTotalTtc = cart => {
        const cartTotal = getCartTotal(cart);
        const normalizedCashBackNumber = Number(cartTotal.toFixed(2));
        return normalizedCashBackNumber;
    };

    const compareCartAmountToValidatedCashback = () => {
        if (validatedCashbackAmount >= getCartTotal()) {
            return false;
        }
        return true;
    };

    return (
        <div id="payment-request-selector-right-container">
            <p className="basket">
                <span>{i18n.BASKET}</span>
            </p>
            <div className="cart-container">
                {cart.length < 1 ? (
                    <p>{i18n.EMPTY_BASKET}</p>
                ) : (
                    <React.Fragment>
                        {cart
                            .sort((a, b) => a.facialValue - b.facialValue)
                            .map((e, i) => {
                                const amount = (e.facialValue || 0) * e.quantityQuery || 0;
                                return (
                                    <BasketRowItem
                                        text={`${i18n.BON_ACHAT} - ${partner.name}`}
                                        ebon={e}
                                        amount={amount}
                                        key={i}
                                        handleItemChange={handleItemChange}
                                        isBasketLimitReached={isBasketLimitReached()}
                                    />
                                );
                            })}
                    </React.Fragment>
                )}
            </div>

            <div>
                <div className="resum-container">
                    <div className="row-text colored">
                        <p>{i18n.TOTAL_TTC}</p>
                        <span className="amount">{formatAmountCurrency(doCartTotalTtc(cart))}</span>
                    </div>
                </div>

                <div className="button-add validateCart">
                    {!loginRequired ? (
                        <ButtonComponent
                            disabled={cart.length <= 0 || compareCartAmountToValidatedCashback()}
                            onClick={() => cartValidation()}
                            color="main"
                            text={i18n.VALIDATE_BASKET}
                        />
                    ) : (
                        <ButtonComponent
                            disabled={cart.length <= 0 || compareCartAmountToValidatedCashback()}
                            onClick={e => showLoginModal(e)}
                            color="main"
                            text={i18n.LOGIN_TO_VALIDATE_BASKET}
                        />
                    )}
                    {compareCartAmountToValidatedCashback() && (
                        <p className="error">{i18n.AMOUNT_SUPERIOR_TO_VALIDATED_CASHBACK}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

EbonSelectorRightContainer.propTypes = {
    partner: PropTypes.object.isRequired,
    cart: PropTypes.array.isRequired,
    handleItemChange: PropTypes.func.isRequired,
    getCartTotal: PropTypes.func.isRequired,
    isBasketLimitReached: PropTypes.func,
    loginRequired: PropTypes.bool.isRequired,
    showLoginModal: PropTypes.func.isRequired,
    validatedCashbackAmount: PropTypes.number.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT.EBON_SELECTOR
    };
};

const mapDispatchToProps = {
    registerCart
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EbonSelectorRightContainer));



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/payment-requests/ebon/ebonselector/EbonSelectorRightContainer.js